import { create } from 'zustand';
import { canPerform, deriveUserRole } from '../utils/identity';
import { guestCooldownRemainingMs } from '../utils/queueLogic';

export const useRoleStore = create((set, get) => ({
  userId: null, // Firebase Auth uid
  hostId: null, // event.hostId
  userRole: null, // derived: 'host' | 'subhost' | 'guest'
  lastSongRequest: null,

  setAuthenticatedUser: (uid) => {
    const { hostId, userRole } = get();
    set({
      userId: uid || null,
      userRole: deriveUserRole(uid, hostId, userRole),
    });
  },

  bindEventIdentity: (hostId, participantRole = null) => {
    const { userId } = get();
    set({
      hostId: hostId || null,
      userRole: deriveUserRole(userId, hostId, participantRole),
    });
  },

  /**
   * Compatibility setter. Identity still comes from uid + hostId.
   * Passing role 'host' without hostId treats the uid as hostId.
   */
  setRole: (role, id) => {
    const userId = id || get().userId;
    const hostId = role === 'host' ? (get().hostId || userId) : get().hostId;
    set({
      userId: userId || null,
      hostId: hostId || null,
      userRole: deriveUserRole(userId, hostId, role),
    });
  },

  resetRole: () => set((state) => ({
    userRole: null,
    hostId: null,
    lastSongRequest: null,
    userId: state.userId,
  })),

  setLastSongRequest: (timestamp) => set({
    lastSongRequest: timestamp,
  }),

  can: (action) => {
    const { userId, hostId, userRole } = get();
    return canPerform(action, { userId, hostId, userRole });
  },

  canRequestSong: () => {
    const { lastSongRequest, userId, hostId, userRole } = get();
    const role = deriveUserRole(userId, hostId, userRole);
    if (role === 'host' || role === 'subhost') return true;

    if (!lastSongRequest) return true;

    return guestCooldownRemainingMs(lastSongRequest) === 0;
  },
}));
